@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@100..700&family=Roboto&display=swap);
@import '../../../../common/hair-quiz-vto/global/global.scss';
@import './variable';
@import './screens/index.scss';
.show {
  display: block;
}
.hide {
  display: none;
}
* {
  --product-wrapper-height: 100%;
}

